<template>
  <div>
    <div class="top">
      <CardSection 
        :title="$t('worksDetail.title')" 
        :text="$t('worksDetail.text')" 
        :work="true"
        :buttonText="$t('worksDetail.button')" 
        href="/works"
        class="maxwidth cardSection"
      />
    </div>
    <div class="container">
      <WorkDetailContent :project="project" class="maxwidth"/>
    </div>
    <div class="bot">
      <FooterComponent class="cardSection scroll-hidden" v-scroll="'scroll-hidden'"/>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import WorkDetailContent from '../components/WorkDetailContent.vue';
import CardSection from '../components/CardSectionComponent.vue';
import FooterComponent from '../components/FooterComponent.vue';
import projects from '../data/projects.json';

export default {
  name: 'WorksDetailPage',
  components: {
    WorkDetailContent,
    CardSection,
    FooterComponent,
  },
  data() {
    return {
      project: null,
    };
  },
  created() {
    const projectSlug = this.$route.params.slug;
    this.project = projects.find((project) => project.slug === projectSlug);

    if (this.project) {
      const isFr = this.$i18n && this.$i18n.locale === 'fr';
      useHead({
        title: `${isFr ? (this.project.companyName_fr || this.project.companyName) : this.project.companyName} X Webeasy`,
        meta: [
          { name: 'description', content: isFr ? (this.project.projectDescription_fr || this.project.projectDescription) : this.project.projectDescription },
          { name: 'keywords', content: `${isFr ? (this.project.companyName_fr || this.project.companyName) : this.project.companyName}, ${this.project.type}, Webeasy, project details, case study, innovative solutions, creative designs, custom development, branding, UI/UX design, responsive design, scalable solutions, client success, digital transformation` },
        ],
      });
    }
  },
};
</script>

<style scoped>
.bot {
  position: relative;
  background: rgb(255,255,255);
background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%);
display: flex;
justify-content: center;
}
  .maxwidth {
    max-width: 1200px;
    margin-left: 4.7vw !important;
    margin-right: 4.7vw !important;
  }
.top {
  position: relative;
  background: rgb(255,255,255);
background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%);
display: flex;
justify-content: center;
}
.cardSection {
  width: 95vw;
  max-width: 1920px;
}
.container {
  display: flex;
  justify-content: center;
  background-color: white;
}
</style>